<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-mapping-renewas-list" class="ag-grid-container">
    <div class="vx-card">
      <grid-panel
          height="md"
          :column-defs="columnDefs"
          :url="() => this.mappingRenewalList"
          :auto-size="true"
          @rowClicked="view"
          class="mapping-renewals-grid"
          @update:deleted="getMappingRenewalList"
          title="Mapping Renewals"
          @rowSelected="onRowSelected"
          ref="mappingRenewalsGrid"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'mapping-renewals.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Map Renewal</span>
          </span>
        </vs-dropdown-item>
        <vs-dropdown-item v-if="componentAccess.canDelete.access" :disabled="!selectedItems.length">
          <span
              class="flex items-center"
              @click="confirmDelete"
          >
            <feather-icon icon="MinusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Delete Selected</span>
          </span>
        </vs-dropdown-item>

      </grid-panel>
    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import ButtonToggle from "../../components/extra-components/toggle/ButtonToggle";
import StatisticsCards from '@/components/statistics-cards/StatisticsCards.vue'

export default {
  components: {
    TGrid,
    GridPanel,
    YesNoToggle,
    ButtonToggle,
    StatisticsCards
  },
  mixins: [CellMatchingMixin, CanAccessMixin],
  data () {
    return {
      componentAccess: {
        canCreate: {
          route: 'mapping-renewals.create',
          access: false,
        },
        canDelete: {
          route: 'mapping-renewals.delete',
          access: false,
        },
        canView: {
          route: 'mapping-renewals.view',
          access: false,
        },
      },
      mappingRenewalList: [],
      searchQuery: '',
      selectedItems: [],

      // AgGrid
      columnDefs: [
        {
          headerName: '',
          field: 'MappingRenewal_PK',
          width: 69,
          maxWidth: 69,
          minWidth: 69,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: false,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Source Product',
          field: 'commercialProductSourceName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Target Product',
          field: 'commercialProductTargetName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Associated Company',
          field: 'companyName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
      ],
    }
  },
  computed: {
    showGridOne() {
      return this.toggleValue === 0;
    },
  },
  created() {
    this.getMappingRenewalList();
  },
  methods: {
    onRowSelected(event) {
      this.toggleProducerSelection(event);
    },
    toggleProducerSelection(params) {
      const isSelected = params.node.isSelected();

      if (isSelected && !this.selectedItems.includes(params.data.MappingRenewal_PK)) {
        this.selectedItems.push(params.data.MappingRenewal_PK);
      } 
      
      if (!isSelected) {
        this.selectedItems = this.selectedItems.filter(id => id !== params.data.MappingRenewal_PK);
      }
    },
    confirmDelete() {
      if (!this.selectedItems.length) {
        return;
      }

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete this Facility`,
        accept: this.deleteSelected,
        acceptText: 'Delete'
      });
    },
    async deleteSelected()
    {
      try {
        this.selectedItems = [...new Set(this.selectedItems)];

        const { data } = await this.$api.mappingRenewals.deleteMultiple(this.selectedItems);
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: 'Mapping Renewals deleted successfully',
          position: 'top-right'
        });
      } catch (e) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error occurred',
          text: 'Failed to delete Mapping Renewals',
          position: 'top-right'
        });
        console.error(e)
      } finally {
        this.selectedItems = [];
        this.getMappingRenewalList();
        this.$refs.mappingRenewalsGrid.list();
      }
    },
    getMappingRenewalList(isDeleted = 0) {
      const params = { IsDeleted: isDeleted };
      this.mappingRenewalList = this.$api.mappingRenewals.list({ params });

      return this.mappingRenewalList;
    },
    view({data}) {
      if (!data || !componentAccess.canView.access) {
        return;
      }

      this.$router.push({ name: 'mapping-renewals.view', params: { id: data.MappingRenewal_PK }}).catch(() => {});
    }
  },

}

</script>

<style lang="scss">
</style>
